import { createSlice } from "@reduxjs/toolkit";
// utils
import { PATH_DASHBOARD } from "../../routes/paths";
import axios from "../../utils/axios";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  update: false,
  teams: [],
  fetchLoading: false,
  singleTeam: null,
  squads: [],
};

const slice = createSlice({
  name: "team",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateTeamSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.teams = state.teams.map((team) => {
        if (team.id === action.payload.id) {
          return action.payload;
        }
        return team;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.update = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getTeamSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.teams = action.payload;
    },

    // GET PRODUCTS
    getSquadSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.squads = action.payload;
    },

    // GET SINGLE SUCCESS
    getSingleTeamSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.singleTeam = action.payload;
    },

    // GET PRODUCTS
    createTeamSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.teams = [...state.teams, action.payload];
    },

    // DELETE EVENT
    deleteTeamSuccess(state, action) {
      const teamId = action.payload;
      state.teams = state.teams.filter((team) => team.id !== teamId);
      state.isLoading = false;
      state.fetchLoading = false;
    },

    resetTeamSuccess(state) {
      state.teams = [];
    },
  },
});

export default slice.reducer;

export function getTeams() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("teams");
      dispatch(slice.actions.getTeamSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function resetTeams() {
  return async (dispatch) => {
    dispatch(slice.actions.resetTeamSuccess());
  };
}

export function getSquads() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("squads");
      dispatch(slice.actions.getSquadSuccess(response.data.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getTeamSeason({ id }) {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get(`teams/${id}`);
      dispatch(slice.actions.getSingleTeamSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createTeam({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("teams", data);
      dispatch(slice.actions.createTeamSuccess(response.data.data));
      enqueueSnackbar("Team is added successfully");
      navigate(PATH_DASHBOARD.teams.list);
    } catch (error) {
      console.log(error, "errorrrr")
      enqueueSnackbar(error.message || "error creating team", {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateTeam({ id, data, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`teams/${id}`, data);
      dispatch(slice.actions.updateTeamSuccess(response.data.data));
      enqueueSnackbar("Team is updated successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteTeam({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`teams/${id}`);
      dispatch(slice.actions.deleteTeamSuccess(id));
      enqueueSnackbar("Team is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
